/**
 * services.js
 *
 * @description Describes services that users can interact with.
 */

export const Service = {
  ALERTING: 'alerting',
  FACES: 'faces',
  IDENTITY: 'identity',
  KEYCARD: 'keycard',
  STAFF: 'staff',
  VIDEO: 'video',
}
